import { useState, useEffect } from 'react';

const useResponsive = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const [showMobileDesignFilters, setShowMobileDesignFilters] = useState(true);
  const [showDesktopDesignFilters, setShowDesktopDesignFilters] = useState(true);

  useEffect(() => {
    const checkIfMobile = () => {
      const isMobileView = window.innerWidth < 1024;
      setIsMobile(isMobileView);
    };

    setIsClient(true);
    checkIfMobile();

    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setShowMobileDesignFilters(true);
      setShowDesktopDesignFilters(false);
    } else {
      setShowDesktopDesignFilters(true);
      setShowMobileDesignFilters(false);
    }
  }, [isMobile]);

  return {
    isMobile,
    isClient,
    showMobileDesignFilters,
    showDesktopDesignFilters,
  };
};

export default useResponsive;
